if (!customElements.get('td-free-shipping-callout')) {
  const SELECTORS = {
    badge: '[data-td-free-shipping-badge]',
  };

  class TdFreeShippingCallout extends HTMLElement {
    connectedCallback() {
      this.badge = this.querySelector(SELECTORS.badge);
      this.threshold = parseInt(this.getAttribute('data-td-threshold'), 10) || 0;

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const price = event && event.data && event.data.variant && event.data.variant.price;
          if (typeof price === 'number') {
            this.updateVisibility(price);
          }
        });
      }
    }

    disconnectedCallback() {
      if (this.variantChangeUnsubscriber) {
        this.variantChangeUnsubscriber();
      }
    }

    updateVisibility(priceInCents) {
      if (!this.badge) return;
      this.badge.hidden = priceInCents < this.threshold;
    }
  }

  customElements.define('td-free-shipping-callout', TdFreeShippingCallout);
}
